import dayjs from 'dayjs';

export const getDate = (dateStr: string) => dayjs(dateStr).format('DD/MM/YYYY');

export const getTime = (dateStr: string) => dayjs(dateStr).format('HH[h]mm');
